// extracted by mini-css-extract-plugin
export default {"banner":"Navbar_banner__bwPZK","image":"Navbar_image__9WKda","navbar":"Navbar_navbar__SmlyJ","navbarButton":"Navbar_navbarButton__L7dpH"};